import type { FontFaceSpec } from '../../types';
import woff2 from '../src/PPMori-ExtraLightNew.woff2';
import woff from '../src/PPMori-ExtraLightNew.woff';

export const ppMoriExtraLight: FontFaceSpec = {
  weight: 200,
  style: 'normal',
  src: [
    { file: woff2, format: 'woff2' },
    { file: woff, format: 'woff' },
  ],
};
